<template>
  <PrintTicketLayout>
    <template v-slot:content>
      <div>
        <table style="border: 0; width: 100%">
          <tr>
            <td style="text-transform: uppercase; text-align: center">{{ $t("Presupuesto") }}</td>
          </tr>
        </table>

        <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

        <table style="border: 0; width: 100%">
          <tr>
            <td style="text-align: left">{{ $t("Nº de presupuesto") }}</td>
            <td style="text-align: right;">{{ presupuesto.num_ticket }}</td>
          </tr>
          <tr>
            <td style="text-align: left">{{ $t("Fecha de presupuesto") }}</td>
            <td style="text-align: right;">{{ presupuesto.fecha | moment('L') }} {{ presupuesto.fecha | moment('HH:mm') }}</td>
          </tr>
          <tr>
            <td style="text-align: left; white-space: pre-line">{{ $t('Cliente') }}</td>
            <td style="text-align: right; white-space: pre-line" v-if="presupuesto.cliente">
              {{ presupuesto.cliente.text }}
            </td>
          </tr>
        </table>

        <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

        <table style="border: 0; width: 100%">
          <tbody>
          <tr>
            <td style="text-align: left; padding: 0;" class="font-weight-bold">{{ $t("Uds.") }}</td>
            <td style="text-align: center; padding: 0;" class="font-weight-bold">{{ $t("Producto") }}</td>
            <td style="text-align: right; padding: 0;" class="font-weight-bold">{{ $t("Importe") }}</td>
          </tr>
          <tr v-for="(currentlinea, index) in presupuesto.lineas_presupuesto" :key="index">
            <td style="text-align: left; padding: 0;">{{ currentlinea.cantidad }}</td>
            <td style="text-align: center; padding: 0;">{{ currentlinea.descripcion }}</td>
            <td style="text-align: right; padding: 0;">{{ currentlinea.total | money }}</td>
          </tr>
          </tbody>
        </table>

        <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

        <table style="border: 0; width: 100%">
          <tbody>
          <tr>
            <td style="text-align: left; padding: 0">{{ $t("Imp.") }}</td>
            <td style="text-align: right; padding: 0">{{ $t('Cuota') }}</td>
            <td />
            <td />
          </tr>
          <tr v-for="(currentlinea, index) in presupuesto.lineas_presupuesto" :key="index">
            <td style="text-align: left; padding: 0">{{ currentlinea.impuesto.valor }}</td>
            <td style="text-align: right; padding: 0">{{ currentlinea.total - (currentlinea.impuesto.valor / 100 * currentlinea.total) | money }}</td>
            <td style="text-align: right; padding: 0">{{ currentlinea.impuesto.valor / 100 * currentlinea.total | money }}</td>
            <td style="text-align: right; padding: 0" class="font-weight-bold">{{ currentlinea.total | money }}</td>
          </tr>
          </tbody>
        </table>

        <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

        <table style="border: 0; width: 100%">
          <tr class="font-weight-bold">
            <td style="text-align: left">{{ $t("Total") }}:</td>
            <td style="text-align: right;">{{ presupuesto.total | money }}</td>
          </tr>
        </table>
      </div>
    </template>
  </PrintTicketLayout>
</template>

<script>
import UserDeviceMixin from "@/mixins/UserDeviceMixin";

export default {
  name: 'PrintTicketPresupuesto',
  mixins: [UserDeviceMixin],
  data: () => ({
    presupuesto: {},
  }),

  methods: {
    async get_presupuesto() {
      this.presupuesto = await this.$store.dispatch("presupuestos/get_presupuesto", this.$route.params.id)
    },

    imprimir() {
      setTimeout(() => {
        if(this.centro.is_pass_print && (['mobile', 'tablet'].includes(this.get_device()))){
          let receiptHTML='<!DOCTYPE html><html><head><title></title><meta charset="UTF-8"><meta name="viewport" content="width=576"></head><body>';
          receiptHTML+=document.getElementById("content_ticket").innerHTML;
          receiptHTML+="</body></html>"
          const receiptB64=encodeURIComponent(receiptHTML);
          location.href = "starpassprnt://v1/print/nopreview?back=null&html=" + receiptB64
        }else{
          window.print()
        }
      }, 500)
    }
  },

  async mounted() {
    await this.get_presupuesto()
    this.imprimir()
  },

  components: {
    PrintTicketLayout: () => import('@/components/impresiones/PrintTicketLayout')
  }
}
</script>
